import paginateAction from '@utils/paginateAction';
import Course from '@models/Course';
import { savedObjectTypes } from '@constants/index';
import { savedTypes } from '../constants';
import { paginatorListSchema } from '../schemas';

export const fetchSavedCount = (goalUid) => (dispatch) =>
  dispatch({
    type: savedTypes.FETCH_SAVED_COUNT,
    endpoint: `v1/uplus/save/home/?goal_uid=${goalUid}`,
    method: 'get',
    goalUid
  });

const getSavedEntities = (key, resetWithoutEmpty, entityType) => (next) => {
  return {
    type: savedTypes.FETCH_SAVED_ENTITY,
    endpoint: next,
    method: 'get',
    key,
    resetWithoutEmpty,
    schema: paginatorListSchema,
    directPaginatedEntity: true,
    entityType: entityType === 3 ? 'question' : 'item',
    processData(data) {
      if (entityType === savedObjectTypes.NOTES) {
        return {
          ...data,
          results: data.results.map((item) => ({
            ...item.liveclass,
            notesCount: item.notes?.item_count,
            topic_groups: item.liveclass.programme?.topic_groups,
            courseUID: item.liveclass.programme?.uid,
            courseSlug: item.liveclass.programme?.slug,
            course: new Course.Course(item.liveclass.programme),
            programme: undefined
          }))
        };
      }
      if (entityType !== savedObjectTypes.QUESTION) {
        return {
          ...data,
          results: data.results.map((item) => ({
            ...item,
            courseUID: item.programme?.uid,
            courseSlug: item.programme?.slug,
            course: Course.Course(item.programme),
            programme: undefined
          }))
        };
      }
      return data;
    }
  };
};

export const fetchSavedEntities = ({
  goalUid,
  nextPage = false,
  resetWithoutEmpty = false,
  keyword = '',
  entityType,
  key,
  forceReset = false
}) => {
  const keywordParam = keyword ? `&keyword=${keyword}` : '';
  return paginateAction(
    `v1/uplus/save/get_entity/?entity_type=${entityType}&goal_uid=${goalUid}&limit=10${keywordParam}`,
    getSavedEntities(key, resetWithoutEmpty, entityType),
    'saved',
    key,
    resetWithoutEmpty,
    forceReset
  )(nextPage);
};

const entityTypeKeyMap = {
  1: 'lessons',
  2: 'tests',
  3: 'questions'
};

export const saveEntity =
  ({ goalUid, entityType, objectUid }) =>
  (dispatch) =>
    dispatch({
      type: savedTypes.SAVE_ENTITY,
      endpoint: 'v1/uplus/save/add_to_saved/',
      method: 'post',
      data: {
        object_uid: objectUid,
        entity_type: entityType
      },
      goalUid,
      key: `${goalUid}-${entityTypeKeyMap[entityType]}`,
      objectUid
    });

export const removeEntityFromSaved =
  ({ goalUid, entityType, objectUid, key }) =>
  (dispatch) =>
    dispatch({
      type: savedTypes.REMOVE_SAVED_ENTITY,
      endpoint: 'v1/uplus/save/remove_from_saved/',
      method: 'post',
      data: {
        object_uid: objectUid,
        entity_type: entityType
      },
      goalUid,
      key,
      objectUid,
      entity: entityType
    });
